<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div v-if="pageLoading" class="mc-loader"><span class="mc-loader__circle"></span></div>
      <div v-if="pageError" class="mc-error">{{ pageError }}</div>
      <div v-if="pageLoaded" class="mc-text-page">
        <h2>
          {{ page.name }}
        </h2>
        <div v-html="page.text"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import blog_detail from "@/store/blog_detail";

export default {
  computed: {
    ...mapGetters([
      'page',
      'pageLoading',
      'pageError',
      'pageLoaded'
    ])
  },
  mounted() {

  },
  created() {
    this.fetchPage(this.$route.params.id);
  },
  components: {},
  methods: {
    ...mapActions([
      'fetchPage',
    ]),
  },
}
</script>

